import Link from 'next/link';
import React from 'react';
import { Icon } from '../../subkit-ui';
import { normalizeLink } from '../../utils/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Socials = function Socials(_ref) {
  var service = _ref.service,
      user = _ref.user;
  var twitter = service.twitter,
      facebook = service.facebook,
      youTube = service.youTube,
      instagram = service.instagram,
      tiktok = service.tiktok,
      linkedin = service.linkedin,
      website = service.website;
  return /*#__PURE__*/_jsx("div", {
    className: "service-social-media w-full justify-center flex flex-row mt-5",
    children: /*#__PURE__*/_jsxs("div", {
      className: "lg:w-1/2 w-1/3 flex  justify-center space-x-6 text-2xl",
      children: [facebook && /*#__PURE__*/_jsx(Link, {
        href: "https://facebook.com/".concat(facebook),
        children: /*#__PURE__*/_jsx("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          "data-cy": "facebook",
          children: /*#__PURE__*/_jsx(Icon, {
            name: "facebook",
            type: "brand",
            className: "clickable text-gray-500 hover:text-gray-900"
          })
        })
      }), twitter && /*#__PURE__*/_jsx(Link, {
        href: "https://twitter.com/".concat(twitter),
        children: /*#__PURE__*/_jsx("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          "data-cy": "twitter",
          children: /*#__PURE__*/_jsx(Icon, {
            name: "twitter",
            type: "brand",
            className: "clickable text-gray-500 hover:text-gray-900"
          })
        })
      }), instagram && /*#__PURE__*/_jsx(Link, {
        href: "https://www.instagram.com/".concat(instagram),
        children: /*#__PURE__*/_jsx("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          "data-cy": "instagram",
          children: /*#__PURE__*/_jsx(Icon, {
            name: "instagram",
            type: "brand",
            className: "clickable text-gray-500 hover:text-gray-900"
          })
        })
      }), youTube && /*#__PURE__*/_jsx(Link, {
        href: "https://www.youtube.com/channel/".concat(youTube),
        children: /*#__PURE__*/_jsx("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          "data-cy": "youtube",
          children: /*#__PURE__*/_jsx(Icon, {
            name: "youtube",
            type: "brand",
            className: "clickable text-gray-500 hover:text-gray-900"
          })
        })
      }), (user === null || user === void 0 ? void 0 : user.email) && /*#__PURE__*/_jsx(Link, {
        href: "mailto:".concat(user.email),
        children: /*#__PURE__*/_jsx("a", {
          "data-cy": "email",
          children: /*#__PURE__*/_jsx(Icon, {
            name: "envelope-square",
            type: "solid",
            className: "clickable text-gray-500 hover:text-gray-900"
          })
        })
      }), linkedin && /*#__PURE__*/_jsx(Link, {
        href: "https://www.linkedin.com/in/".concat(linkedin),
        children: /*#__PURE__*/_jsx("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          "data-cy": "linkedin",
          children: /*#__PURE__*/_jsx(Icon, {
            name: "linkedin",
            type: "brand",
            className: "clickable text-gray-500 hover:text-gray-900"
          })
        })
      }), tiktok && /*#__PURE__*/_jsx(Link, {
        href: "https://www.tiktok.com/@".concat(tiktok),
        children: /*#__PURE__*/_jsx("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          "data-cy": "tiktok",
          children: /*#__PURE__*/_jsx(Icon, {
            name: "tiktok",
            type: "brand",
            className: "clickable text-gray-500 hover:text-gray-900"
          })
        })
      }), website && /*#__PURE__*/_jsx(Link, {
        href: "".concat(normalizeLink(website)),
        children: /*#__PURE__*/_jsx("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          "data-cy": "website",
          children: /*#__PURE__*/_jsx(Icon, {
            name: "globe",
            type: "solid",
            className: "clickable text-gray-500 hover:text-gray-900"
          })
        })
      })]
    })
  });
};